import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  questionsListContainer: {
    maxWidth: '800px',
    minWidth: '75%',
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
  },
  actionButtonsBlock: {
    maxWidth: '800px',
    minWidth: '75%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  modalText: {
    fontSize: 18,
    textAlign: 'center',
  },
});
